module.exports = __webpack_public_path__ + "media/images/work_articles_tab1_icon-on-ef8191c0e47c71bd4422870170731aa1.png";